import { QuestionnaireSectionProps } from '@/types/questionnaire';
import { AdminBreadcrumb } from '../../components/AdminBreadcrumb';

export function QuestionsBreadcrumb({
  templateId,
  templateTitle,
  section,
}: {
  templateId: number;
  templateTitle: string;
  section: QuestionnaireSectionProps;
}) {
  return (
    <AdminBreadcrumb
      items={[
        { label: 'Applications', href: '/admin/questionnaire_templates' },
        {
          label: templateTitle,
          href: `/admin/questionnaire_templates/${templateId}/questionnaire_sections?section_id=${section.id}`,
        },
        { label: section.section_name, isCurrentPage: true },
      ]}
    />
  );
}
